import React from 'react';
import { ProspectsManagement } from '../../components/users-view/ProspectsManagement';

export const ProspectsManagementPage: React.FC = () => {
  
  return (
    <>
      <ProspectsManagement />
    </>
  );
};

export default ProspectsManagementPage;
